const API_VERSION = 'v2';
const apiRoot = `${process.env.REACT_APP_API_ENDPOINT}/${API_VERSION}/`;

const callApi = (endpoint, headers, method, body) => {	
	var options = { headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
		...headers,
	  }, method:method };

	if(body !== null){
		options.body = JSON.stringify(body)
	}
	const url = apiRoot + endpoint;
	return fetch(url, options);
};
export default callApi;


